export const SCHEDULED_RUN_TIMES_ENUM = Object.freeze({
  SELECT: -1,
  DAILY: 0,
  HOURLY: 1,
  EVERY_15_MINUTES: 2,
});

export const SCHEDULED_RUN_TIMES_DATA = [
  { value: SCHEDULED_RUN_TIMES_ENUM.SELECT, text: "Select a Run Schedule" },
  { value: SCHEDULED_RUN_TIMES_ENUM.DAILY, text: "Daily" },
  { value: SCHEDULED_RUN_TIMES_ENUM.HOURLY, text: "Hourly" },
  {
    value: SCHEDULED_RUN_TIMES_ENUM.EVERY_15_MINUTES,
    text: "Every 15 Minutes",
  },
];
